import MakeCreditBuilding from 'features/believe/application/MakeCreditBuildingScreen/MakeCreditBuilding';
import React from 'react';

export default function MakeCreditBuildingPage() {
  return <MakeCreditBuilding />;
}
